import axios from '../../plugins/axios'

export const listAllServices = () => {
  const apiAddress = `api/oportunidadventa/listar-servicios`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    return response.data.results || response.data
  })
}

export const listOvAll = (_, data) => {
  const params = new URLSearchParams()
  params.append('page', data.page || 1)

  if (data.estado && data.estado !== 'Todas') {
    params.append('search', data.estado)
  }

  if (data.params) {
    params.append('params', data.params)
  }
  if (data.ordering) {
    params.append('ordering', data.ordering)
  }

  const apiAddress = `api/oportunidadventa/get-ov?${params.toString()}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    return response.data
  })
}

export const getEstadosOV = ({}) => {
  const apiAddress = `api/oportunidadventa/get-estados-ov`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    return response.data
  })
}

export const listOvActions = ({ commit }, ovId) => {
  const apiAddress = `api/oportunidadventa/get-ov-actions/${ovId}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    commit('SET_OV_ACTIONS', { ovActions: response.data })
  })
}

export const getOvDetail = ({ commit }, ovId) => {
  const apiAddress = `api/oportunidadventa/get-ov/${ovId}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    commit('SET_OV_DETAIL', { ovDetail: response.data })
    return response
  })
}

export const createOv = (_, data) => {
  const apiAddress = `api/oportunidadventa/oportunidad-precompleta`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const acceptOv = (_, data) => {
  const apiAddress = `api/oportunidadventa/aceptar-oportunidad`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const declineOv = (_, data) => {
  const apiAddress = `api/oportunidadventa/rechazar-oportunidad`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const patchOv = (_, id, data) => {
  const apiAddress = `api/oportunidadventa/patch-ov/${id}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.patch(apiAddress, data, config).then((response) => response)
}

export const prepareNewQuotation = (_, { id_oportunidad_venta }) => {
  const apiAddress = `api/oportunidadventa/preparar-nueva-cotizacion`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, { id_oportunidad_venta }, config)
    .then((response) => response)
}

export const cambiarEnvio = (_, { id_oportunidad_venta, costo_envio }) => {
  const apiAddress = `api/oportunidadventa/cambiar-a-envio`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, { id_oportunidad_venta, costo_envio }, config)
    .then((response) => response)
}

export const sendQuotation = (_, data) => {
  const apiAddress = `api/oportunidadventa/enviar-cotizacion`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const sendPayment = (_, data) => {
  console.log(data)
  const apiAddress = `api/oportunidadventa/ingresar-pago`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const requestParts = (_, data) => {
  const apiAddress = `api/oportunidadventa/pedir-repuestos-bodega`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const receivePartsStore = (_, data) => {
  const apiAddress = `api/oportunidadventa/recibir-repuestos-bodega`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const receivePartsExecutive = (_, data) => {
  const apiAddress = `api/oportunidadventa/recibir-repuestos-logistica`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const closeDeclinedOv = (_, data) => {
  const apiAddress = `api/oportunidadventa/cerrar-rechazado-oportunidad`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const exportOvExcelRange = ({}, date) => {
  const apiAddress = `/api/oportunidadventa/generar_excel_ovs_por_fecha?fecha_inicio=${date.fecha_inicio}&fecha_final=${date.fecha_final}&type=${date.type}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .get(apiAddress, config)
    .then((response) => {
      return response
    })
    .catch((error) => error.response)
}

export const validateRMA = ({}, data) => {
  const apiAddress = `api/oportunidadventa/validate-rma?rma=${data}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response)
}

export const setRMA = ({}, data) => {
  const apiAddress = `api/oportunidadventa/set-rma`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const newOportunidadCompleta = ({}, data) => {
  const apiAddress = `api/oportunidadventa/oportunidad-completada-new`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const getPartInfo = ({}, { id_parte }) => {
  const apiAddress = `api/oportunidadventa/info-parte-ov?parte_id=${id_parte}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const updateOvPrecompletada = ({}, data) => {
  const apiAddress = `api/oportunidadventa/update-ov-precompletada`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const crearExcepcion = (_, data) => {
  const apiAddress = `api/oportunidadventa/crear-excepcion`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const requestAbonoException = crearExcepcion

export const listExceptions = (_, data = {}) => {
  const { page = 1, estado, search } = data

  let apiAddress = `api/oportunidadventa/listar-excepciones?page=${page}`
  if (estado && estado !== 'TODAS') {
    apiAddress += `&estado=${estado}`
  }
  if (search) {
    apiAddress += `&search=${search}`
  }
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    return response.data
  })
}

export const getExceptionCounts = () => {
  const apiAddress = `api/oportunidadventa/conteo-excepciones`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const manageException = (_, data) => {
  const apiAddress = `api/oportunidadventa/gestionar-excepcion`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

export const getExceptionDetail = (_, exceptionId) => {
  const apiAddress = `api/oportunidadventa/detalle-excepcion?id=${exceptionId}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

// Nuevas acciones para selección de empresas
export const getEmpresaDatosPrellenado = (_, empresaId) => {
  const apiAddress = `api/oportunidadventa/empresa/${empresaId}/datos-prellenado`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const getSucursalDatosPrellenado = (_, sucursalId) => {
  const apiAddress = `api/orden/sucursal/${sucursalId}/datos-prellenado`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response.data)
}

export const recalcularPDFCotizacion = (_, data) => {
  const apiAddress = `api/oportunidadventa/recalcular-pdf-cotizacion`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response)
}

// Nuevas acciones para Revisar Cotización (SILL-1366)
export const getDetalleRevisionCotizacion = (_, ovId) => {
  const apiAddress = `api/quotes/cotizaciones/${ovId}/detalle-revision/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = { headers: { Authorization: `Token ${key}` } }
  return axios.get(apiAddress, config).then((response) => response)
}

export const regenerarPDFCotizacion = (_, ovId) => {
  const apiAddress = `api/quotes/cotizaciones/${ovId}/regenerar-pdf/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = { headers: { Authorization: `Token ${key}` } }
  return axios.post(apiAddress, {}, config).then((response) => response)
}

export const aprobarCotizacion = (_, ovId) => {
  const apiAddress = `api/quotes/cotizaciones/${ovId}/aprobar/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = { headers: { Authorization: `Token ${key}` } }
  return axios.post(apiAddress, {}, config).then((response) => response)
}

export const rechazarRevisionCotizacion = (_, ovId) => {
  const apiAddress = `api/quotes/cotizaciones/${ovId}/rechazar-revision/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = { headers: { Authorization: `Token ${key}` } }
  return axios.post(apiAddress, {}, config).then((response) => response)
}

export const reingresarEvaluacion = (_, ovId) => {
  const apiAddress = `api/quotes/cotizaciones/${ovId}/reingresar-evaluacion/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = { headers: { Authorization: `Token ${key}` } }
  return axios.post(apiAddress, {}, config).then((response) => response)
}

// Acciones para Cambiar Boleta a Factura (SILL-1586)
export const cambiarBoletaAFactura = (_, data) => {
  const apiAddress = `api/oportunidadventa/cambiar-boleta-a-factura`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response.data)
}

export const reintentarFactura = (_, data) => {
  const apiAddress = `api/oportunidadventa/reintentar-factura`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.post(apiAddress, data, config).then((response) => response.data)
}

export const consultarContribuyente = (_, rut) => {
  const apiAddress = `api/oportunidadventa/contribuyente/${rut}/`
  return axios.get(apiAddress).then((response) => response.data)
}
